import type { FC } from 'react';
import { groupBy } from 'lodash';
import { Text } from '@eo-locale/react';
import { useQuery } from 'react-query';
import { HistoryApi } from '../api';
import { Table } from '../components';

export const HistoryPage: FC = () => {
  const { data } = useQuery('user-history', HistoryApi.fetch);

  const group = [
    ...(data?.structureAuthority.data ?? []),
    ...(data?.commissions?.data ?? [])
  ]
  const groupedByDepartaments = groupBy(group, ({ name }) => name);

  return (<div>
    {
      Object.entries(groupedByDepartaments).map(([departament, item]) => {
        return (<>
          <h2 className='p-1 bg-slate-200'>{departament}</h2>
          {

            Object.entries(groupBy(item, ({ authority }) => authority)).map(([authority, e]) => {
              return (
                <Table className='ml-4 bg-slate-50'>
                  <h2>{authority.toLowerCase().includes('komis') ? authority : ''}</h2>
                  <thead>
                    <tr>
                      <th>
                        <Text id="comissions:function" />
                      </th>
                      <th>
                        <Text id="comissions:start_date" />
                      </th>
                      <th>
                        <Text id="comissions:end_date" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <>

                      {
                        e.map((i, id) => {
                          return <tr key={id}>
                            <td>{i.authority.toLowerCase().includes('komis') ? i.function : i.authority}</td>
                            <td>{i.start_date}</td>
                            <td>{i.end_date ?? i.deleted_at}</td>
                          </tr>
                        })
                      }
                    </>
                  </tbody>
                </Table>
              )
            })}

        </>)
      })
    }
  </div>)
}